import { BaseApi } from './base';

class Letters extends BaseApi {
  constructor() {
    super('letters');
  }

  getHiragana() {
    return this.get('/hiragana-letters')
  }

  getKatakana() {
    return this.get('/katakana-letters')
  }

  getWords() {
    return this.get('/words');
  }

  getWord(id) {
    return this.get(`/words/${id}`)
  }

  getLetter(id) {
    return this.get(`/${id}`)
  }

  getHiraganaLetter(id) {
    return this.get(`/hiragana-letters/${id}`)
  }

  getKatakanaLetter(id) {
    return this.get(`/katakana-letters/${id}`)
  }

  getTest() {
    return this.get('/test');
  }

}

export default new Letters();
